import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { QRCodeHorodaty } from '@/components/ui/app/qr-code';
import { AppleStoreIcon } from '@/components/ui/app/icons/apple-store';
import { GooglePlayIcon } from '@/components/ui/app/icons/google-play';
import { useTheme } from '@/lib/contexts/theme-context';
import { useTranslation } from 'react-i18next';

export function DialogMobileApp({ open, onOpenChange }) {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const { storeLinks } = theme;
    const showQrCode = theme.qrCode?.show;
    const hasStoreLinks = storeLinks?.appStore || storeLinks?.googlePlay;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-xl">
                <DialogHeader>
                    <DialogTitle>{t('common:telechargerLApplicationMobile')}</DialogTitle>
                    <DialogDescription>
                        {t('common:pourAjouterDesPhotosUtilisezLApplication')} {theme.name} {t('common:surMobile')}
                        {showQrCode ? t('common:scannezCeQrCodePourLaTelecharger') : ''}
                    </DialogDescription>
                </DialogHeader>
                <section className="bg-secondary rounded-lg overflow-hidden">
                    <div className="flex flex-col md:flex-row gap-8 p-10 items-center">
                        {showQrCode && (
                            <div className="bg-background p-4 rounded-xl shadow-lg">
                                <QRCodeHorodaty size={96} />
                            </div>
                        )}
                        <div className="flex flex-col justify-center text-secondary-foreground">
                            <h3 className="text-3xl font-black mb-4 leading-none text-center md:text-start">
                                {t('common:commencezACertifier')}
                            </h3>
                            {hasStoreLinks && (
                                <div className="flex gap-4 items-center">
                                    {storeLinks.appStore && (
                                        <Button variant="solid" color="primary" asChild>
                                            <a href={storeLinks.appStore} target="_blank" rel="noopener noreferrer">
                                                <AppleStoreIcon />
                                                {t('common:appStore')}
                                            </a>
                                        </Button>
                                    )}
                                    {storeLinks.googlePlay && (
                                        <Button variant="solid" color="primary" asChild>
                                            <a href={storeLinks.googlePlay} target="_blank" rel="noopener noreferrer">
                                                <GooglePlayIcon />
                                                {t('common:googlePlay')}
                                            </a>
                                        </Button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </DialogContent>
        </Dialog>
    );
}
